import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'udrNotification' })
export class UdrNotificationPipe implements PipeTransform {
	transform(value: any, args: string[]): any {
		if (!value) {
			return '';
		} else {
			let result = value.toLowerCase().includes('Webhook'.toLowerCase());
			if (!result)
				return "Streaming";
			return "Webhook";
		}
	}
}